import { Container } from "@material-ui/core";
export const AppContainer = ({children}) => 
{
    return <Container maxWidth="md">{children}</Container>
}